var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":_vm.maxWidth,"persistent":_vm.persistent},model:{value:(_vm.internalDialog),callback:function ($$v) {_vm.internalDialog=$$v},expression:"internalDialog"}},[_c('v-card',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }